import React, { Component } from 'react';
import Layout from './Layout';
import properties from '../../modules/ajio-util/properties';

export default class NotFoundPage extends Component {
  render() {
    return (
      <Layout>
        <div className="main-view-fluid">
          <NotFoundPageContent />
        </div>
      </Layout>
    );
  }
}

export class NotFoundPageContent extends Component {
  componentDidMount() {
    if (window.ga) {
      window.ga('send', {
        hitType: 'event',
        eventCategory: 'service error',
        eventAction: window.pageType,
        eventLabel: `OOPS_${window.location.pathname}`
      });
    }
  }

  render() {
    return (
      <a href="/">
        <img
          src={`${properties.getProperty('imageBaseUrl')}/static/img/404.jpg`}
          width="100%"
          alt="Page not available image"
        />
      </a>
    );
  }
}
